import { PeriodOptionSet } from './createPeriodOptions.ts';
import { PeriodOption, Resolution } from '../report-settings/reportSettings.ts';

export function getPeriods(periodOptionSet: PeriodOptionSet, resolution: Resolution): PeriodOption[] {
    const periodsByResolution = {
        Days: periodOptionSet.days,
        Weeks: periodOptionSet.weeks,
        Months: periodOptionSet.months,
    };
    // Keep the original period objects: the date-range summary and calendar dialog use
    // indexOf to find the report's first/last selected periods. Copies would not match.
    return periodsByResolution[resolution];
}
